module.exports = __webpack_public_path__ + "img/banner__img.fe5bcb68.webp";